import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sameCheckbox", "shippingFields"];

  connect() {
    this.toggle();
  }

  toggle() {
    this.shippingFieldsTarget.classList.toggle("d-none", this.sameCheckboxTarget.checked);
  }
}
